import { render, staticRenderFns } from "./BreaksNotifier.vue?vue&type=template&id=05beb30e&"
import script from "./BreaksNotifier.vue?vue&type=script&setup=true&lang=js&"
export * from "./BreaksNotifier.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports